import React from 'react';
import { i18nFn, useSpringBigStore } from '@springbig/shared';
import { VStack, Pressable, Box } from 'native-base';
import { Caption, H3 } from '~/shared/Typography';
import Button from '~/shared/Button';
import { useGeneralStyles } from '~/shared/styles';
import { SpIcon } from '~/shared/Icon';
import { faComments } from '@fortawesome/free-solid-svg-icons';
import Image from '~/shared/Image';

type WelcomeStepProps = {
    t: i18nFn;
    onEvent: (message: string) => void;
};

export const WelcomeStep = ({
    t,
    onEvent,
}: WelcomeStepProps) => {

    const gStyle = useGeneralStyles();
    const { member } = useSpringBigStore();

    const handleViewMessage = (): void => {

        onEvent('messages');
    };

    // const onSeeMenu = (): void => {
    //
    //     console.log('see menu');
    // };

    const onDismiss = (): void => {

        onEvent('messages');
    };

    return (
        <VStack space={8} w={'100%'} alignItems={'center'}>
            <Box
                bg={ member?.tendlc_logo ? null : gStyle.button_background }
                rounded={'full'}
                p={ member?.tendlc_logo ? 0 : 8 }
            >
                { member && member.tendlc_logo ?
                    <Image
                        w={200}
                        h={200}
                        rounded={'full'}
                        uri={`${member.tendlc_logo}`}
                    />
                    :
                    <SpIcon icon={faComments} size={120} color={'white'} />
                }
            </Box>
            <VStack w={'100%'}>
                <H3 fontSize={20}>
                    { member?.first_name ? t('auth.ten_dlc.welcome.title', [member.first_name]) : t('auth.ten_dlc.welcome.title_anonymous') }
                </H3>
                <Caption maxW={'100%'}>
                    { t('auth.ten_dlc.welcome.description') }
                </Caption>
                <Caption maxW={'100%'}>
                    { t('auth.ten_dlc.welcome.description_two') }
                </Caption>
            </VStack>
            <VStack w={'100%'} space={4}>
                <Button
                    bg={gStyle.button_background}
                    _text={{ color: gStyle.button_text }}
                    onPress={handleViewMessage}
                >
                    { t('auth.ten_dlc.view_message') }
                </Button>
                {/*<Button*/}
                {/*    bg={gStyle.button_neutral_background}*/}
                {/*    _text={{ color: gStyle.button_neutral_text }}*/}
                {/*    onPress={onSeeMenu}*/}
                {/*>*/}
                {/*    { t('auth.ten_dlc.see_menu') }*/}
                {/*</Button>*/}
                <Pressable
                    alignSelf={'center'}
                    onPress={onDismiss}
                >
                    <Caption color={gStyle.link}>
                        { t('auth.ten_dlc.dismiss') }
                    </Caption>
                </Pressable>
            </VStack>
        </VStack>
    );
};
